import { render, staticRenderFns } from "./StepFour.vue?vue&type=template&id=7bf72e5b&scoped=true&lang=pug"
import script from "./StepFour.vue?vue&type=script&lang=js"
export * from "./StepFour.vue?vue&type=script&lang=js"
import style0 from "./StepFour.vue?vue&type=style&index=0&id=7bf72e5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf72e5b",
  null
  
)

export default component.exports